import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SessionService } from 'src/app/services/session.service';
import * as moment from 'moment';

@Component({
	selector: 'app-vaccinationpassport',
	templateUrl: './vaccinationpassport.component.html',
	styleUrls: ['./vaccinationpassport.component.css'],
})
export class VaccinationpassportComponent implements OnInit {
	passportForm: FormGroup;
	newsletterForm: FormGroup;
	submitted = false;
	submitted_news = false;
	apiUrl: any;
	isRecovered: boolean = false;
	file: any;
	filePath: any;
	fileUrl1: any;
	fileUrl2: any;
	fileUrl3: any;
	date: Date;

	// tslint:disable-next-line: max-line-length
	constructor(
		private formBuilder: FormBuilder,
		private httpClient: HttpClient,
		private router: Router,
		private sess: SessionService,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	ngOnInit() {
		this.date = new Date();
		this.initializeForm();

		$('.mobile-menu').css('display', 'none');
	}

	initializeForm() {
		this.passportForm = this.formBuilder.group({
			name: [
				'',
				[
					Validators.required,
					Validators.pattern('^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$'),
					Validators.maxLength(45),
				],
			],
			email: ['', [Validators.required, Validators.email]],
			f_date: ['', [Validators.required]],
			f_dose_certificate: ['', [Validators.required]],
			s_date: ['', [Validators.required]],
			s_dose_certificate: ['', [Validators.required]],
			gender: ['', [Validators.required]],
			dob: ['', [Validators.required]],
			vaccineName: [
				'',
				[
					Validators.required,
					// Validators.pattern('^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$'),
					Validators.maxLength(45),
				],
			],
			vaccinationPlace: [
				'',
				[
					Validators.required,
					// Validators.pattern('^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$'),
					Validators.maxLength(45),
				],
			],
			vaccinationCountry: [
				'',
				[
					Validators.required,
					Validators.pattern('^[A-Za-z ]*$'),
					Validators.maxLength(45),
				],
			],
			is_recover: ['', [Validators.required]],
			recover_certificate: ['', []],
			phone: [
				'',
				[
					Validators.required,
					Validators.pattern('^[0-9]*$'),
					Validators.minLength(7),
					Validators.maxLength(13),
				],
			],
		});
	}

	onSubmit(formAllData: any) {
		this.submitted = true;
		if (this.passportForm.invalid) {
			return;
		}

		const obj = {
			full_name: formAllData.name,
			gender: formAllData.gender,
			dob: formAllData.dob,
			phone: formAllData.phone,
			email: formAllData.email,
			first_dose_date: formAllData.f_date,
			second_dose_date: formAllData.s_date,
			ever_positive: formAllData.is_recover,
			first_dose_filepath: this.fileUrl1,
			second_dose_filepath: this.fileUrl2,
			negative_report: this.fileUrl3,
			vaccine_name: formAllData.vaccineName,
			vaccination_place: formAllData.vaccinationPlace,
			vaccination_country: formAllData.vaccinationCountry,
		};

		this.postPassportForm(obj);
	}

	postPassportForm(jsondata) {
		this.spinnerService.show();
		this.apiUrl = environment.AUTHAPIURL + 'collect-vaccination-data';
		const config = {
			headers: {
				Accept: 'application/json',
				Authorization: 'Bearer ' + localStorage.getItem('access_token'),
			},
		};
		this.httpClient
			.post<any>(this.apiUrl, jsondata, config)
			.subscribe((data) => {
				// console.log("appointmentDetails: ", data);
				if (data.status == true) {

					 // Rest form fithout errors
					 this.passportForm.reset();
					 Object.keys(this.passportForm.controls).forEach(key => {
					   this.passportForm.get(key).setErrors(null);
					 });
					this.spinnerService.hide();
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: data.message,
						showConfirmButton: true,
						timer: 4000,
					});
				} else {
					Swal.fire({
						icon: 'info',
						title: 'Success',
						text:
							data.response != null ? data.response[0].message : data.message,
						showConfirmButton: true,
						timer: 4000,
					});
					this.spinnerService.hide();
				}
			});
	}

	checkRecovery(event) {
		this.submitted = true;
		let recover = event.target.value;
		if (recover == 1) {
			this.isRecovered = true;
		}
	}

	hasFile(event) {
		if (event.target.files.length > 0) {
			this.submitted = false;
			this.isRecovered = false;
		} else {
			this.submitted = true;
			this.isRecovered = true;
		}
	}

	onFileChange(event, certType) {
		if (certType == 3) {
			this.hasFile(event);
		}
		if (event.target.files.length > 0) {
			this.spinnerService.show();

			const file = event.target.files[0];
			this.file = event.target.files[0];
			this.filePath = event.target.files[0].name;
			// this.passportForm.get('resultFile').setValue(file);

			this.apiUrl = environment.AUTHAPIURL + 'file/upload';
			// 	'Content-Type': 'application/json',
			// 	Authorization: 'Bearer ' + localStorage.getItem('access_token'),
			// });
			const formData = new FormData();
			formData.append('file', this.file);

			// this.fileUrl =
			// 	'http://localhost/eg-ctms-backend/public/uploadReport/sample-COVID-test-report_1624438663.jpg';
			this.httpClient.post<any>(this.apiUrl, formData).subscribe((data) => {
				console.log('uploadApiResponse: ', data);
				this.spinnerService.hide();

				if (data.status == true) {
					if (certType == 1) {
						this.fileUrl1 = data.response.url;
						console.log(this.fileUrl1);
					} else if (certType == 2) {
						this.fileUrl2 = data.response.url;
						console.log(this.fileUrl2);
					} else if (certType == 3) {
						this.fileUrl3 = data.response.url;
						console.log(this.fileUrl3);
					}

					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: data.message,
						showConfirmButton: true,
						timer: 5000,
					});
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text:
							data.response != null ? data.response[0].message : data.message,
						showConfirmButton: true,
						timer: 5000,
					});
				}
			});
		}
	}
}
